<template>
    <div :class="['sideNav','reveal','active',skinMode ==0 ? 'dots':'spread']">
        <ul>            
            <li 
                v-for="(item, index) in pages" :key="index"
                @click="setItem(index)"
                :style="getCountAndIndexVars(index)"
                :class="[index==selectedIndex ? 'selected' : '']">
                    <span></span>
                     <span v-if="item[0]!=null && item[0].length>0">
                        {{localize(item[0])}}
                    </span>
             </li>
        </ul>
    </div>
</template>
<script>

import { mapActions, mapState } from "vuex";
import { isMobileScreen }         from "@/utils";

export default {
    name: "sidepager",
    props: {
        skinMode:{
            default:0,
            Number
        },
        itemIndex:{
            default:0,
            type:Number
        },
        sectionIndex:{
            default:0,
            type:Number
        },
        items:{
            default:'',
            type:String | Number | Boolean | Object
        },
        itemsPerPage:{
            default:1,type:Number
        },
        mobilePagesCount:{
            default:1,type:Number
        }

        //skinMode:Number,
        //itemIndex:Number,
        //sectionIndex:Number,
        //items:Object,
        //itemsPerPage:Number
    },
    data()
    {
        //sideDots
        //spreadLines
        return {
            pages:[],
            sectionData:[],
            selectedIndex:0
        }
    },
    created()
    {
    },
    mounted()
    {        
        var vm = this;
        this.$nextTick(() => {
            this.initPager();
            this.onResizeElement();
            window.addEventListener('resize', vm.onResizeElement); 
        })

    },
    watch:{
        items:function(newVal,oldVal)
        {
            //this.sectionData = newVal;
        },
        itemIndex:function(newVal,oldVal){
            //alert("new = "+newVal);
            this.selectedIndex = Number(newVal);
        }
    },
    methods:
    {
        initPager()
        {
            if(this.items){
                this.$set(this, "sectionData", this.items);
            }else{
                this.sectionData = this.minisite_data.SECTIONS[this.sectionIndex].items;
            }            
        },
        onResizeElement()
        {
            this.pages = [];
            let pagesCount = this.getPagesCount;//<<this will change according to desktop/mobile mode
            for(var i=0;i<pagesCount;i++){
                this.pages.push(i);
            }
        },
      getCountAndIndexVars(index){
        //return "--count:"+this.sectionData.length+";--index:"+index;
        return "--count:"+this.pages.length+";--index:"+index;
      },
        setItem(index)
        {
            //alert(index);
            this.selectedIndex = index;
            this.$emit('item-change',index);
        }
    },
    computed:{
      ...mapState(["minisite_data"]),
      getPagesCount()
      {
        let pagesCount = this.sectionData.length;
        let isMobile = false; 
        var winWidth = window.innerWidth;
        this.scrWidth = winWidth;
        if(this.scrWidth<850){
            isMobile=true;
        }
        if(isMobile==false){
            if(this.itemsPerPage && this.itemsPerPage>1){
                pagesCount=Math.ceil(pagesCount/Number(this.itemsPerPage));
            }
        }else{
            pagesCount= this.mobilePagesCount;//5;//pagesCount;//5;////???
        }
        return pagesCount;
      }
    }
};
</script>

<style>
    .sideNav{
        padding: 20px;
    }
    .sideNav.spread,
    .sideNav.dots
    {
        width: 100%;padding: 0px;
    }
    .sideNav ul{
        list-style: none;margin: auto;
    }

    .sideNav ul li{
        clear: both;
        padding: 6px 0px;
        cursor: pointer;
        position: relative;
    }
    .sideNav.spread ul li,
    .sideNav.dots ul li
    {
        clear: none;float: left;
        width: calc(100% / var(--count));
        padding: 0px 2px;
    }

    .sideNav ul li span:nth-child(1){
        width: 10px;height: 10px;
        opacity: 0;
        background-color: #1894e2;
        border-radius: 40px;
        display: block;
        transition: all ease 0.3s;
        transform: scale(0.1) translateY(50px);
        transition-property: all;
        transition-duration: 0.8s;
        transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
        transition-delay: calc(var(--index)*0.1s);
        margin: auto;
    }
    .sideNav.active ul li span:nth-child(1){
        background-color: #d8d8d8;
        transform: scale(1) translateY(0);
        opacity: 1;
    }



    .sideNav.spread ul li span:nth-child(1){
        width: 100%;height: 7px;
        border-radius: 0px;
    }

    .sideNav ul li.selected span:nth-child(1)
    {
        background-color: #1894e2;
    }

    .sideNav.spread ul li span:nth-child(2)
    {
        display: none;
    }
    .sideNav ul li span:nth-child(2)
    {
        position:absolute;
        font-size: 11px;
        top: -1px;
        left: -8px;
        transform: translate(-100%,50%);
        width: 300px;
        text-align: right;
        pointer-events: none;
        opacity: 0;
        transition: all ease 0.3s;
        margin: auto;
    }

    @media (hover: hover) 
    {
        .sideNav ul li:hover span:nth-child(1)
        {
            background-color: #1894e2;
        }
        .sideNav ul li:hover span:nth-child(2)
        {
            opacity: 1;
        }    
    }    

    @media screen and (max-width: 815px)
    {
        .sideNav
        {
            height: 80px;
            padding-top: 20px !important;        
        }
        .sideNav ul li:nth-child(n+6){
            display: none;
        }      
    }

</style>